<section id="formats" class="wl-section formats">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Formaty gier"
      title="To nie jest zwykły quiz"
      subtitle="Sprawdź, kto naprawdę zna Młodych." />
    <div class="narrow">
      <div class="card">
        <div class="glow"></div>
        <div class="row">
          <div class="icon"><svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#B08947" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2" fill="#B08947" stroke="none"/></svg></div>
          <div class="content">
            <h3 class="title">Quiz o parze młodej</h3>
            <p class="desc">Para młoda przygotowuje pytania o sobie — goście odpowiadają ze swoich telefonów. Wyniki lecą na duży ekran i robią się rozmowy, śmiechy i niespodzianki.</p>
            <div class="tags">
              <div class="pill">
                <span class="pill-dot"></span>Dostępne teraz
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
